import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from '../../constants';

const RECENT_CONFIGS_PUT = createApiConstants(NAMESPACE, 'RECENT_CONFIGS_PUT');
const SAVED_CONFIGS_PUT = createApiConstants(NAMESPACE, 'SAVED_CONFIGS_PUT');

export default {
  RECENT_CONFIGS_PUT,
  SAVED_CONFIGS_PUT,
};
